module.exports = __webpack_public_path__ + "img/handraw_fraicheur_marron.46242617.svg";